import React from 'react';
import { Event } from '@material-ui/icons';
import FormConfigDate from '../../config/FormConfigDate';
import { FormDateField } from '../../fields/FormDateField';
export const FormDateFieldPlugin = {
    icon: React.createElement(Event, null),
    name: 'Date',
    type: 'Date',
    dataTypes: ['date'],
    configurator: FormConfigDate,
    element: FormDateField
};
//# sourceMappingURL=FormDateFieldPlugin.js.map